// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5828 7.17043L16.8279 1.41553L12.4872 5.75656L18.2421 11.5115L22.5828 7.17043Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.8279 12.9257L11.073 7.17082L1.99976 16.2448L1.99976 21.9997L7.75469 21.9997L16.8279 12.9257Z"}}]};

const Edit1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'edit-1-filled',
    ref,
    icon: element,
  },
));

Edit1FilledIcon.displayName = 'Edit1FilledIcon';

export default Edit1FilledIcon;
